import React from 'react';
import DateRange from '../date-range/DateRange';
import DateFilter from '../date-filter/DateFilter';
import FilterDropdown from '../filter-dropdown/FilterDropdown';
import BatchFilterDropdown from '@common-components/filter-dropdown/BatchFilterDropdown';

const StatisticsFilters = ({supplierName, setSupplierName, suppliers, selectSupplier, setSelectSupplier, selectBatch, setSelectBatch , setBatchData}) => {

  return (
    <React.Fragment>
      <div className='flex flex-col- gap-3 2xl:space-y-0 space-y-3 2xl:flex-row 2xl:items-center items-center justify-between mb-3'>
        <p className="mb-0 text-xl font-medium min-w-[max-content] w-auto 2xl:w-100">{supplierName ? supplierName : localStorage.getItem('supplierName')}</p>
        {/* <DateRange />
          <DateFilter /> */}
        <div className='flex gap-4 justify-end items-center w-100 mb-0 2xl:mb-4'>
          <FilterDropdown setSupplierName = {setSupplierName} suppliers={suppliers} selectSupplier={selectSupplier} setSelectSupplier={setSelectSupplier} setSelectBatch = {setSelectBatch} setBatchData = {setBatchData} />
          <BatchFilterDropdown setBatchData = {setBatchData} suppliers={suppliers} selectBatch={selectBatch} setSelectBatch={setSelectBatch} selectSupplier={selectSupplier} setSelectSupplier = {setSelectSupplier} />
          {/* <DateFilter />
          <DateRange /> */}
        </div>

      </div>
    </React.Fragment>
  );
}

export default StatisticsFilters;
